import { render, staticRenderFns } from "./square-index.vue?vue&type=template&id=287a63c8&scoped=true"
import script from "./square-index.vue?vue&type=script&lang=js"
export * from "./square-index.vue?vue&type=script&lang=js"
import style0 from "./square-index.vue?vue&type=style&index=0&id=287a63c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287a63c8",
  null
  
)

export default component.exports